import { type PayloadAction, createSlice } from "@reduxjs/toolkit"

import { generateSetPropReducer } from "../../../redux/shared/set-setate-prop.reducer.ts"
import { documentTemplateSliceName } from "./document-templates.constants.ts"
import {
  type DocumentTemplatesFilters,
  type DocumentTemplatesState
} from "./document-templates.types.ts"
import {
  fetchAvailableBlocks,
  fetchTemplates
} from "./thunks/document-templates.thunks.ts"

const initialState: DocumentTemplatesState = {
  data: {
    results: [],
    count: 0,
    next: null,
    previous: null
  },
  filters: {
    page: 1,
    page_size: 10
  },
  availableBlocks: [],
  availableBlocksStatus: "idle",
  fetching: false
}

const documentTemplatesSlice = createSlice({
  name: documentTemplateSliceName,
  initialState,
  reducers: {
    proposalTemplatesSetProp: generateSetPropReducer<DocumentTemplatesState>(),

    documentTemplatesSetFilters: (
      state,
      action: PayloadAction<Partial<DocumentTemplatesFilters>>
    ) => {
      state.filters = { ...state.filters, ...action?.payload }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAvailableBlocks.pending, (state) => {
        state.availableBlocksStatus = "loading"
      })
      .addCase(fetchAvailableBlocks.fulfilled, (state, action) => {
        state.availableBlocks = action?.payload?.all
        state.availableBlocksStatus = "succeeded"
      })
      .addCase(fetchAvailableBlocks.rejected, (state) => {
        state.availableBlocks = initialState.availableBlocks
        state.availableBlocksStatus = "failed"
      })

    // fetchTemplates
    builder
      .addCase(fetchTemplates.pending, (state) => {
        state.fetching = true
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.data = action.payload
        state.fetching = false
      })
      .addCase(fetchTemplates.rejected, (state) => {
        state.fetching = false
        state.data = initialState.data
      })

    // // Delete template
    // builder.addCase(deleteTemplate.fulfilled, (state, action) => {
    //   state.data.results = state.data.results.filter(
    //     (template) => template.id !== action.meta.arg
    //   )
    //   state.data.count = Math.max(0, state.data.count - 1)
    // })
    //
    // // Duplicate template
    // builder.addCase(duplicateTemplate.fulfilled, (state, action) => {
    //   const firstRemovableIndex = state.data.results.findIndex(
    //     (item) => item.removable
    //   )
    //   const insertAt =
    //     firstRemovableIndex !== -1
    //       ? firstRemovableIndex
    //       : state.data.results.length
    //
    //   state.data.results.splice(insertAt, 0, action.payload)
    //   state.data.count = state.data.count + 1
    // })
    //
    // builder.addCase(logout.fulfilled, () => {
    //   console.log("proposal templates logout")
    //   return initialState
    // })
  }
})

export const { proposalTemplatesSetProp, documentTemplatesSetFilters } =
  documentTemplatesSlice.actions
export default documentTemplatesSlice
